const authClientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const apiPrefix: 'dev.' | '' = import.meta.env.VITE_API_PREFIX as 'dev.' | '';
const devMode = !!import.meta.env.VITE_DEV_MODE;
const tutorialEnabled = !!import.meta.env.VITE_TUTORIAL;
const noSurfacesEnabled = !!import.meta.env.VITE_NO_SURFACES;

if (apiPrefix !== '' && apiPrefix !== 'dev.') {
    throw new Error('Invalid environment');
}

export { authClientId, apiPrefix, devMode, tutorialEnabled, noSurfacesEnabled };
